/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useCallback } from 'react';

import { GoTriangleRight } from 'react-icons/go';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import Accordion from '../../components/Accordion';
import DashboardLayout from '../../components/DashboardLayout';
import LoaderSubLine from '../RoutesAndLines/LoaderSubLine';
import { ReactComponent as Bus } from '../../assets/Shared/Bus.svg';
import { Container, CollapseContainer, TimeContainer } from './styles';
import { ReactComponent as ClockIcon } from '../../assets/RoutesAndLines/clock.svg';
import AccountsService from '../../services/accounts';
import api from '../../services/api';
import Loader from '../../components/Loader';

interface Favoritas {
  id: number;
  user: number;
  code_line: string;
  name_line: string;
  sgl_line: string;
  follow: boolean;
}

interface Itineraries {
  code: string;
  sgl: string;
  name: string;
  itinerario: any;
  tabelahorario: any;
}

const Favoritos: React.FC = () => {
  const servicesAccounts = { AccountsService: new AccountsService() };
  const [favoritas, setFavoritas] = useState<Favoritas[]>([]);
  const [linhas, setLinhas] = useState<Itineraries[]>([]);
  const [subLinhas, setSubLinhas] = React.useState<any>([]);
  const [subLines, setSubLines] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [loadingSubLine, setLoadingSubLine] = React.useState<boolean>(false);

  const estacoes = [
    {
      linha: '1000',
      nome: 'ESTAÇÃO DIAMANTE',
      display: '1000 - ESTAÇÃO DIAMANTE',
    },
    {
      linha: '1001',
      nome: 'LINHA DE BLOQUEIO ESTAÇÃO DIAMANTE',
      display: '1001 - LINHA DE BLOQUEIO ESTAÇÃO DIAMANTE',
    },
    {
      linha: '1002',
      nome: 'LINHA BLOQUEIO ESTAÇÃO DIAMANTE ACESSO LOJAS',
      display: '1002 - LINHA BLOQUEIO ESTAÇÃO DIAMANTE ACESSO LOJAS',
    },
    {
      linha: '2000',
      nome: 'ESTACAO VENDA NOVA',
      display: '2000 - ESTACAO VENDA NOVA',
    },
    {
      linha: '2001',
      nome: 'LINHA DE BLOQUEIO ESTAÇÃO VENDA NOVA',
      display: '2001 - LINHA DE BLOQUEIO ESTAÇÃO VENDA NOVA',
    },
    {
      linha: '3000',
      nome: 'ACESSO ESTAÇÃO SAO GABRIEL',
      display: '3000 - ACESSO ESTAÇÃO SAO GABRIEL',
    },
    {
      linha: '3001',
      nome: 'LINHAS BLOQUEIO SÃO GABRIEL',
      display: '3001 - LINHAS BLOQUEIO SÃO GABRIEL',
    },
    {
      linha: '3002',
      nome: 'LINHA BLOQUEIO MOVE SÃO GABRIEL (TARIFA A)',
      display: '3002 - LINHA BLOQUEIO MOVE SÃO GABRIEL (TARIFA A)',
    },
    {
      linha: '4001',
      nome: 'LINHA DE BLOQUEIO ESTAÇÃO BARREIRO',
      display: '4001 - LINHA DE BLOQUEIO ESTAÇÃO BARREIRO',
    },
    {
      linha: '4002',
      nome: 'ESTAÇAO BARREIRO',
      display: '4002 - ESTAÇAO BARREIRO',
    },
    {
      linha: '4003',
      nome: 'ESTAÇÃO BARREIRO SAÍDA / ACESSO SHOPPING',
      display: '4003 - ESTAÇÃO BARREIRO SAÍDA / ACESSO SHOPPING',
    },
    {
      linha: '4004',
      nome: 'LINHA DE BLOQUEIO ESTAÇÃO BARREIRO ACESSO LOJAS',
      display: '4004 - LINHA DE BLOQUEIO ESTAÇÃO BARREIRO ACESSO LOJAS',
    },
    {
      linha: '6000',
      nome: 'ACESSO ESTAÇÃO PAMPULHA',
      display: '6000 - ACESSO ESTAÇÃO PAMPULHA',
    },
    {
      linha: '6001',
      nome: 'LINHAS BLOQUEIO ESTAÇÃO PAMPULHA',
      display: '6001 - LINHAS BLOQUEIO ESTAÇÃO PAMPULHA',
    },
    {
      linha: '7000',
      nome: 'LINHAS ACESSO ESTAÇÃO VILARINHO',
      display: '7000 - LINHAS ACESSO ESTAÇÃO VILARINHO',
    },
    {
      linha: '7001',
      nome: 'LINHAS BLOQUEIO ESTAÇÃO VILARINHO',
      display: '7001 - LINHAS BLOQUEIO ESTAÇÃO VILARINHO',
    },
    {
      linha: 'AC01',
      nome: 'ESTAÇÃO TRANSF. CANDELÁRIA',
      display: 'AC01 - ESTAÇÃO TRANSF. CANDELÁRIA',
    },
    {
      linha: 'AC02',
      nome: 'ESTAÇÃO TRANSF. MINAS CAIXA',
      display: 'AC02 - ESTAÇÃO TRANSF. MINAS CAIXA',
    },
    {
      linha: 'AC03',
      nome: 'ESTAÇÃO TRANSF. QUADRAS DO VILARINHO',
      display: 'AC03 - ESTAÇÃO TRANSF. QUADRAS DO VILARINHO',
    },
    {
      linha: 'AC04',
      nome: 'ESTAÇÃO TRANSF. UPA VENDA NOVA',
      display: 'AC04 - ESTAÇÃO TRANSF. UPA VENDA NOVA',
    },
    {
      linha: 'AC05',
      nome: 'ESTAÇÃO TRANSF. CRISTIANO GUIMARÃES',
      display: 'AC05 - ESTAÇÃO TRANSF. CRISTIANO GUIMARÃES',
    },
    {
      linha: 'AC06',
      nome: 'ESTAÇÃO TRANSF. PLANALTO',
      display: 'AC06 - ESTAÇÃO TRANSF. PLANALTO',
    },
    {
      linha: 'AC07',
      nome: 'ESTAÇÃO TRANSF. SÃO JOÃO BATISTA',
      display: 'AC07 - ESTAÇÃO TRANSF. SÃO JOÃO BATISTA',
    },
    {
      linha: 'AC08',
      nome: 'ESTAÇÃO TRANSF. LAGOA DO NADO',
      display: 'AC08 - ESTAÇÃO TRANSF. LAGOA DO NADO',
    },
    {
      linha: 'AC09',
      nome: 'ESTAÇÃO TRANSF. MONTESE',
      display: 'AC09 - ESTAÇÃO TRANSF. MONTESE',
    },
    {
      linha: 'AC10',
      nome: 'ESTAÇÃO TRANSF. MONTE CASTELO',
      display: 'AC10 - ESTAÇÃO TRANSF. MONTE CASTELO',
    },
    {
      linha: 'AC12',
      nome: 'ESTAÇÃO TRANSF. SANTA ROSA',
      display: 'AC12 - ESTAÇÃO TRANSF. SANTA ROSA',
    },
    {
      linha: 'AC13',
      nome: 'ESTAÇÃO TRANSF. MINEIRÃO',
      display: 'AC13 - ESTAÇÃO TRANSF. MINEIRÃO',
    },
    {
      linha: 'AC14',
      nome: 'ESTAÇÃO TRANSF. UFMG',
      display: 'AC14 - ESTAÇÃO TRANSF. UFMG',
    },
    {
      linha: 'AC15',
      nome: 'ESTAÇÃO TRANSF. LIBERDADE',
      display: 'AC15 - ESTAÇÃO TRANSF. LIBERDADE',
    },
    {
      linha: 'AC16',
      nome: 'ESTAÇÃO TRANSF. COLÉGIO MILITAR',
      display: 'AC16 - ESTAÇÃO TRANSF. COLÉGIO MILITAR',
    },
    {
      linha: 'AC17',
      nome: 'ESTAÇÃO TRANSF. SÃO FRANCISCO',
      display: 'AC17 - ESTAÇÃO TRANSF. SÃO FRANCISCO',
    },
    {
      linha: 'AC18',
      nome: 'ESTAÇÃO TRANSF. CACHOEIRINHA',
      display: 'AC18 - ESTAÇÃO TRANSF. CACHOEIRINHA',
    },
    {
      linha: 'AC19',
      nome: 'ESTAÇÃO TRANSF. AMÉRICO VESPÚCIO',
      display: 'AC19 - ESTAÇÃO TRANSF. AMÉRICO VESPÚCIO',
    },
    {
      linha: 'AC20',
      nome: 'ESTAÇÃO TRANSF. APARECIDA',
      display: 'AC20 - ESTAÇÃO TRANSF. APARECIDA',
    },
    {
      linha: 'AC21',
      nome: 'ESTAÇÃO TRANSF. OPERÁRIOS',
      display: 'AC21 - ESTAÇÃO TRANSF. OPERÁRIOS',
    },
    {
      linha: 'AC22',
      nome: 'ESTAÇÃO TRANSF. HOSPITAL BELO HORIZONTE',
      display: 'AC22 - ESTAÇÃO TRANSF. HOSPITAL BELO HORIZONTE',
    },
    {
      linha: 'AC23',
      nome: 'ESTAÇÃO TRANSF. IAPI',
      display: 'AC23 - ESTAÇÃO TRANSF. IAPI',
    },
    {
      linha: 'AC24',
      nome: 'ESTAÇÃO TRANSF. HOSPITAL ODILON BEHRENS',
      display: 'AC24 - ESTAÇÃO TRANSF. HOSPITAL ODILON BEHRENS',
    },
    {
      linha: 'CM02',
      nome: 'ESTAÇÃO DE TRANSF. MINAS SHOPPING',
      display: 'CM02 - ESTAÇÃO DE TRANSF. MINAS SHOPPING',
    },
    {
      linha: 'CM03',
      nome: 'ESTAÇÃO DE TRANSF. OURO MINAS',
      display: 'CM03 - ESTAÇÃO DE TRANSF. OURO MINAS',
    },
    {
      linha: 'CM04',
      nome: 'ESTAÇÃO DE TRANSF. UNIÃO',
      display: 'CM04 - ESTAÇÃO DE TRANSF. UNIÃO',
    },
    {
      linha: 'CM05',
      nome: 'ESTAÇÃO DE TRANSF. IPIRANGA',
      display: 'CM05 - ESTAÇÃO DE TRANSF. IPIRANGA',
    },
    {
      linha: 'CM06',
      nome: 'ESTAÇÃO DE TRANSF. CIDADE NOVA',
      display: 'CM06 - ESTAÇÃO DE TRANSF. CIDADE NOVA',
    },
    {
      linha: 'CM07',
      nome: 'ESTAÇÃO DE TRANSF. FEIRA DOS PRODUTORES',
      display: 'CM07 - ESTAÇÃO DE TRANSF. FEIRA DOS PRODUTORES',
    },
    {
      linha: 'CM08',
      nome: 'ESTAÇÃO DE TRANSF. SÃO JUDAS TADEU',
      display: 'CM08 - ESTAÇÃO DE TRANSF. SÃO JUDAS TADEU',
    },
    {
      linha: 'CM09',
      nome: 'ESTAÇÃO DE TRANSF. SAGRADA FAMÍLIA',
      display: 'CM09 - ESTAÇÃO DE TRANSF. SAGRADA FAMÍLIA',
    },
    {
      linha: 'PR01',
      nome: 'ESTAÇÃO DE TRANSF. TAMOIOS',
      display: 'PR01 - ESTAÇÃO DE TRANSF. TAMOIOS',
    },
    {
      linha: 'PR02',
      nome: 'ESTAÇÃO DE TRANSF. CARIJÓS',
      display: 'PR02 - ESTAÇÃO DE TRANSF. CARIJÓS',
    },
    {
      linha: 'SD01',
      nome: 'ESTAÇÃO DE TRANSF. SÃO PAULO',
      display: 'SD01 - ESTAÇÃO DE TRANSF. SÃO PAULO',
    },
    {
      linha: 'SD02',
      nome: 'ESTAÇÃO DE TRANSF. RIO DE JANEIRO',
      display: 'SD02 - ESTAÇÃO DE TRANSF. RIO DE JANEIRO',
    },
    {
      linha: 'AC25',
      nome: 'ESTAÇÃO TRANSF. SENAI',
      display: 'AC25 - ESTAÇÃO TRANSF. SENAI',
    },
    {
      linha: 'AC26',
      nome: 'ESTAÇÃO TRANSF. LAGOINHA',
      display: 'AC26 - ESTAÇÃO TRANSF. LAGOINHA',
    },
    {
      linha: 'CM10',
      nome: 'ESTAÇÃO DE TRANSF. SILVIANO BRANDÃO',
      display: 'CM10 - ESTAÇÃO DE TRANSF. SILVIANO BRANDÃO',
    },
  ];
  useEffect(() => {
    async function getLinhas() {
      try {
        setLoading(true);
        const response = await api.get('/core/lines/');
        console.log(response);
        setLinhas(response.data.lines);
        console.log(response.data.lines);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    }
    getLinhas();
  }, [setLinhas]);

  useEffect(() => {
    async function getFavoritas() {
      setLoading(true);
      try {
        const response = await servicesAccounts.AccountsService.getLineFavorite();
        setFavoritas(response.data.results);
        console.log(response);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    }
    getFavoritas();
  }, []);

  const handleSublines = useCallback(async (cod: any) => {
    setLoadingSubLine(true);
    const response = await api.get(`/core/sub-lines/${cod}/`);
    console.log(response);
    const responseSubLinhas = response.data.sub_lines.map(async (sub: any) => {
      const responsibles = await api.get(`/core/v2/line-info/${sub.cod}/`);
      return responsibles.data;
    });
    const promisesResponse = await Promise.all(responseSubLinhas);

    const responsibleses = await api.get(`/core/sub-lines/${cod}/`);
    const sublinhas = responsibleses.data.sub_lines.map((sub: any) => sub);
    const sublinhass = responsibleses.data.sub_lines.map((sub: any) => sub.nom);
    console.log({ sublinhass });
    const changedResponse = promisesResponse.map((item: any) => {
      const filteredSubline = response.data.sub_lines.filter(
        (subline: any) => subline.cod === Number(item.code),
      )[0];
      return { ...item, sublineName: filteredSubline.nom };
    });
    setSubLinhas(sublinhas);
    setSubLines(changedResponse);
    console.log(changedResponse);
    setLoadingSubLine(false);
    return {};
  }, []);

  return (
    <DashboardLayout>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Container>
            <h1 className="title">Linhas e Estações Favoritas</h1>
            {!linhas.length && <span>Nenhuma linha favorita</span>}
            {favoritas &&
              favoritas.map((linha: any) => {
                console.log(linha);
                const isEstacao = estacoes.some(
                  (estacao: any) => estacao?.linha === linha?.code_line,
                );
                return (
                  <Accordion
                    key={linha?.code_line}
                    cod={linha?.code_line}
                    CollapseIcon={GoTriangleRight}
                    title={linha?.sgl_line}
                    subTitle={linha?.name_line}
                    Icon={isEstacao ? 'teste' : Bus}
                    IconEst="teste"
                    handleSublines={handleSublines}
                    hasSublines
                    QrCode
                  >
                    {loadingSubLine ? (
                      <LoaderSubLine />
                    ) : (
                      <>
                        {subLinhas[1] &&
                          subLines.map((sub: any) => (
                            <Accordion
                              key={sub.code}
                              CollapseIcon={GoTriangleRight}
                              title={linha.sgl}
                              subTitle={sub.sublineName}
                            >
                              <CollapseContainer>
                                {Object.keys(sub.tabelahorario).map(
                                  (rota: any) => (
                                    <>
                                      <h3>{rota}</h3>
                                      {Object.keys(sub.tabelahorario[rota]).map(
                                        (dia: any) => (
                                          <>
                                            {!dia.includes('Covid') && (
                                              <TimeContainer key={dia}>
                                                <div className="sub-ball-container">
                                                  <div>
                                                    <ClockIcon />
                                                  </div>
                                                </div>
                                                <div className="text-container">
                                                  <h1>{dia}</h1>
                                                  <div className="flex">
                                                    {sub.tabelahorario[rota][
                                                      dia
                                                    ].map((item: any) => (
                                                      <div
                                                        className="horario"
                                                        key={item}
                                                      >
                                                        {item}
                                                      </div>
                                                    ))}
                                                  </div>
                                                </div>
                                              </TimeContainer>
                                            )}
                                          </>
                                        ),
                                      )}
                                    </>
                                  ),
                                )}
                                <h1>Itinerário</h1>
                                {Object.keys(sub.itinerario).map(
                                  (ponto: any) => (
                                    <>
                                      <div className="text-container">
                                        <h3
                                          className="localizacao-pontos"
                                          key={ponto}
                                        >
                                          {ponto}
                                        </h3>
                                      </div>
                                      {Object.keys(sub.itinerario[ponto]).map(
                                        (localizacao: any) => (
                                          <div key={localizacao}>
                                            {sub.itinerario[ponto][localizacao]}
                                          </div>
                                        ),
                                      )}
                                    </>
                                  ),
                                )}
                              </CollapseContainer>
                            </Accordion>
                          ))}
                      </>
                    )}
                  </Accordion>
                );
              })}
          </Container>
        </>
      )}
    </DashboardLayout>
  );
};

export default Favoritos;
